import { Component, Input} from '@angular/core';
import { Subscription } from 'rxjs';
import { HelpersService } from '../../../services/helpers.service';
import { VersionsModel } from '../../../models/file.model';
import { FileToolbarController } from '../file-toolbar/file-toolbar.component';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
    selector: 'app-doc-version-list',
    templateUrl: './doc-version-list.component.html',
    styleUrl: './doc-version-list.component.scss',
 
})
export class AppDocVersionListComponent {
  @Input() public fileToolbarController: FileToolbarController|null = null;
  private subs:Subscription = new Subscription
  public versions: VersionsModel[] = [] 
  public savedCountLabel:string = ''
  public selectedVersion:number = 0
  public userNamesMap:Map<string,string> = new Map()
  public dateLabelsMap:Map<number,string> = new Map()
  public monthNames = ['января, ', 'февраля, ', 'марта, ', 'апреля, ', 'мая, ', 'июня, ','июля, ' , 'августа, ', 'сентября, ', 'октября, ', 'ноября, ', 'декабря, '
            ]
  constructor(
    private helpersService:HelpersService,
    private dialogRef:MatDialogRef<AppDocVersionListComponent>
  ){}
  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }
  ngOnInit(): void {
      this.versions.forEach(ver=>this.userNamesMap.set(ver.owner.guid,this.helpersService.shortFullName(ver.owner)))
      this.savedCountLabel = this.setSavedCountLabel(this.versions.length)
      this.versions = this.versions
      this.setDateLabels()
  }
  setSavedCountLabel(count:number):string {
    switch (true==true) {
      case count == 1: return ' сохранение'
      case [2,3,4].includes(count): return ' сохранения'
      case count>=5: return ' сохранений'
      default: return ''
    }
  }
  setDateLabels(){
    this.versions.forEach((el,index)=>{
      let createdDate = new Date(el.created_at)
      let yearLabel = createdDate.getFullYear() === new Date().getFullYear()? '' : createdDate.getFullYear() + ', '
      let dateLabel ='' + yearLabel  + createdDate.getDay() +' ' + (this.monthNames[createdDate.getMonth()]) + createdDate.getHours()+':'+createdDate.getMinutes()
      index === 0? dateLabel = createdDate.getHours()+':'+createdDate.getMinutes() : null
      this.dateLabelsMap.set(el.id,dateLabel)
    })
  }
  selectVersion(version:VersionsModel) {
    this.selectedVersion = version.id
  }
  restoreCurrentVersion(){
    let version = this.versions.find(el=>el.id === this.selectedVersion)
    version && this.fileToolbarController? this.fileToolbarController.$onSelectVersion.next(version) :null
    this.dialogRef.close()
  }
  cancelAction() {
    //this.selectedVersion = this.versions[0].id
    this.dialogRef.close()
    //this.restoreCurrentVersion()
  }
}